'use client';

import { Breadcrumb, Container, PublicPageHeading } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const StaticSections: React.FC<{ title: string }> = ({ title }) => {
  const { t } = useTranslation('pages');

  return (
    <>
      <Container>
        <Breadcrumb
          list={[
            { title: t('home.home'), href: routes.home.url },
            {
              title: title,
              href: routes.brand.href('code'),
            },
          ]}
        />
      </Container>
      <PublicPageHeading title={title} />
    </>
  );
};

export default StaticSections;
